import request from '@/utils/request';

export function getAudioIndex() {
  return request({
    url: '/Audio/index_paging',
    silentRequest: true,
  });
}

export function getAudioList(params, silentRequest = false) {
  return request({
    url: '/Audio/explore',
    params,
    silentRequest,
  });
}

export function getAudioDetail(id) {
  return request({
    url: '/Audio/detail_paging',
    params: { id },
    silentRequest: true,
  });
}

export function joinAudio(id) {
  return request({
    url: '/Audio/join',
    method: 'POST',
    data: {
      targetType: 'audio',
      targetId: id,
    },
  });
}

export function getAudioFreeIndex() {
  return request({
    url: '/Audio/freeIndex',
    silentRequest: true,
  });
}

export function getAudioIntroductionInfo(id) {
  return request({
    url: '/Audio/introduction',
    params: {
      id,
    },
  });
}
